<template>
     <div>
        <v-layout wrap align-center justify-center class="px-2">
            <v-flex xs12 class="pb-3">
                <div class="title success--text">
                    {{ $t("enrollment.steps.want_to_change.password.title") }}
                </div>
                <div class="pt-2 secondary--text subheading">
                    {{ $t("enrollment.steps.want_to_change.password.subtitle") }}
                </div>
            </v-flex>
        </v-layout>
        <v-card-actions>
            <v-btn
            :class="[$vuetify.rtl ? 'ml-2' : '']"
            color="primary background--text"
            flat
            @click.stop="skipPassword"
            >{{ $t("enrollment.steps.skip.later.button") }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
            :class="[$vuetify.rtl ? 'mx-0' : '']"
            color="primary background--text"
            @click.stop="goToStep(DEFINES.ENROLLMENT_STEPS.CHANGE_PASSWORD)"
            >{{ $t("enrollment.steps.skip.continue.button") }}</v-btn>
        </v-card-actions>
    </div>
</template>

<script>
export default {
    name:"EnrollmentAskToSetPassword",
    methods:{
        skipPassword(){
            this.$emit("onSkip");
        },
        goToStep(step){
            this.$emit("onConfirm",step);
        },
    }

}
</script>

<style>

</style>
